import React from "react";
import { Helmet } from "react-helmet-async";
import config from "../config";

const SEO = ({ seo }) => {

  if (!seo) return null;

  const absoluteUrl = seo.page_url?.startsWith('http') ? seo.page_url : `${config.siteURL}${seo.page_url}`;

  return (
    <Helmet>

      <title>{`${seo.title} | SSJ`}</title>

      <meta name="description" content={seo.description} />

      <meta property="og:title" content={seo.title} />

      <meta property="og:description" content={seo.description} />

      <meta property="og:image" content={seo.image} />
      <meta property="og:image:alt" content={seo.title} />

      <meta property="og:url" content={absoluteUrl} />

      <link rel="canonical" href={absoluteUrl} />

    </Helmet>
  );
};

export default SEO;